import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/standing-book'

export function getDashboardYunliang() {
  return request({
    url: `${BASE_REQUEST}/dashboard/yunliang`,
    method: 'get'
  })
}

export function getDashboardShipline() {
  return request({
    url: `${BASE_REQUEST}/dashboard/shipline`,
    method: 'get'
  })
}

export function getDashboardTop5Profits() {
  return request({
    url: `${BASE_REQUEST}/dashboard/top5-profits`,
    method: 'get'
  })
}

export function getDashboardCostProfitsTrend() {
  return request({
    url: `${BASE_REQUEST}/dashboard/cost-profits-trend`,
    method: 'get'
  })
}

export function selectstandinglist(queryParams) {
  return request({
    url: `${BASE_REQUEST}/selectstandinglist`,
    data:queryParams,
    method: 'get'
  })
}
export function getCustomerAnalysis(queryParams) {
  return request({
    url: `${BASE_REQUEST}/getCustomerAnalysis`,
    data:queryParams,
    method: 'get'
  })
}
export function getFundOccupation(queryParams) {
  return request({
    url: `${BASE_REQUEST}/getFundOccupation`,
    data:queryParams,
    method: 'get'
  })
}

export function getIndexSummary(data) {
  return request({
    url: `${BASE_REQUEST}/index/summary`,
    method: 'get',
    data
  })
}
export function getIndexDiff(data) {
  return request({
    url: `${BASE_REQUEST}/index/diff`,
    method: 'get',
    data
  })
}

export function getMoneyUsed(queryParams) {
  return request({
    url: `${BASE_REQUEST}/getMoneyUsed`,
    data:queryParams,
    method: 'get'
  })
}
